/**
 * @fileoverview gRPC-Web generated client stub for minibook.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v6.33.4
// source: minibook/v1/minibook.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as minibook_v1_minibook_pb from '../../minibook/v1/minibook_pb'; // proto import: "minibook/v1/minibook.proto"


export class MiniBookServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListTemplates = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/ListTemplates',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.ListTemplatesRequest,
    minibook_v1_minibook_pb.ListTemplatesResponse,
    (request: minibook_v1_minibook_pb.ListTemplatesRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.ListTemplatesResponse.deserializeBinary
  );

  listTemplates(
    request: minibook_v1_minibook_pb.ListTemplatesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.ListTemplatesResponse>;

  listTemplates(
    request: minibook_v1_minibook_pb.ListTemplatesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.ListTemplatesResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.ListTemplatesResponse>;

  listTemplates(
    request: minibook_v1_minibook_pb.ListTemplatesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.ListTemplatesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/ListTemplates',
        request,
        metadata || {},
        this.methodDescriptorListTemplates,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/ListTemplates',
    request,
    metadata || {},
    this.methodDescriptorListTemplates);
  }

  methodDescriptorGetTemplate = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/GetTemplate',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.GetTemplateRequest,
    minibook_v1_minibook_pb.GetTemplateResponse,
    (request: minibook_v1_minibook_pb.GetTemplateRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.GetTemplateResponse.deserializeBinary
  );

  getTemplate(
    request: minibook_v1_minibook_pb.GetTemplateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.GetTemplateResponse>;

  getTemplate(
    request: minibook_v1_minibook_pb.GetTemplateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.GetTemplateResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.GetTemplateResponse>;

  getTemplate(
    request: minibook_v1_minibook_pb.GetTemplateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.GetTemplateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/GetTemplate',
        request,
        metadata || {},
        this.methodDescriptorGetTemplate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/GetTemplate',
    request,
    metadata || {},
    this.methodDescriptorGetTemplate);
  }

  methodDescriptorCreateTemplate = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/CreateTemplate',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.CreateTemplateRequest,
    minibook_v1_minibook_pb.CreateTemplateResponse,
    (request: minibook_v1_minibook_pb.CreateTemplateRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.CreateTemplateResponse.deserializeBinary
  );

  createTemplate(
    request: minibook_v1_minibook_pb.CreateTemplateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.CreateTemplateResponse>;

  createTemplate(
    request: minibook_v1_minibook_pb.CreateTemplateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.CreateTemplateResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.CreateTemplateResponse>;

  createTemplate(
    request: minibook_v1_minibook_pb.CreateTemplateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.CreateTemplateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/CreateTemplate',
        request,
        metadata || {},
        this.methodDescriptorCreateTemplate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/CreateTemplate',
    request,
    metadata || {},
    this.methodDescriptorCreateTemplate);
  }

  methodDescriptorCreateProject = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/CreateProject',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.CreateProjectRequest,
    minibook_v1_minibook_pb.CreateProjectResponse,
    (request: minibook_v1_minibook_pb.CreateProjectRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.CreateProjectResponse.deserializeBinary
  );

  createProject(
    request: minibook_v1_minibook_pb.CreateProjectRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.CreateProjectResponse>;

  createProject(
    request: minibook_v1_minibook_pb.CreateProjectRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.CreateProjectResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.CreateProjectResponse>;

  createProject(
    request: minibook_v1_minibook_pb.CreateProjectRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.CreateProjectResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/CreateProject',
        request,
        metadata || {},
        this.methodDescriptorCreateProject,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/CreateProject',
    request,
    metadata || {},
    this.methodDescriptorCreateProject);
  }

  methodDescriptorGetProject = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/GetProject',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.GetProjectRequest,
    minibook_v1_minibook_pb.GetProjectResponse,
    (request: minibook_v1_minibook_pb.GetProjectRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.GetProjectResponse.deserializeBinary
  );

  getProject(
    request: minibook_v1_minibook_pb.GetProjectRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.GetProjectResponse>;

  getProject(
    request: minibook_v1_minibook_pb.GetProjectRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.GetProjectResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.GetProjectResponse>;

  getProject(
    request: minibook_v1_minibook_pb.GetProjectRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.GetProjectResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/GetProject',
        request,
        metadata || {},
        this.methodDescriptorGetProject,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/GetProject',
    request,
    metadata || {},
    this.methodDescriptorGetProject);
  }

  methodDescriptorUpdateProjectPage = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/UpdateProjectPage',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.UpdateProjectPageRequest,
    minibook_v1_minibook_pb.UpdateProjectPageResponse,
    (request: minibook_v1_minibook_pb.UpdateProjectPageRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.UpdateProjectPageResponse.deserializeBinary
  );

  updateProjectPage(
    request: minibook_v1_minibook_pb.UpdateProjectPageRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.UpdateProjectPageResponse>;

  updateProjectPage(
    request: minibook_v1_minibook_pb.UpdateProjectPageRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.UpdateProjectPageResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.UpdateProjectPageResponse>;

  updateProjectPage(
    request: minibook_v1_minibook_pb.UpdateProjectPageRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.UpdateProjectPageResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/UpdateProjectPage',
        request,
        metadata || {},
        this.methodDescriptorUpdateProjectPage,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/UpdateProjectPage',
    request,
    metadata || {},
    this.methodDescriptorUpdateProjectPage);
  }

  methodDescriptorExportProject = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/ExportProject',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.ExportProjectRequest,
    minibook_v1_minibook_pb.ExportProjectResponse,
    (request: minibook_v1_minibook_pb.ExportProjectRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.ExportProjectResponse.deserializeBinary
  );

  exportProject(
    request: minibook_v1_minibook_pb.ExportProjectRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.ExportProjectResponse>;

  exportProject(
    request: minibook_v1_minibook_pb.ExportProjectRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.ExportProjectResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.ExportProjectResponse>;

  exportProject(
    request: minibook_v1_minibook_pb.ExportProjectRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.ExportProjectResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/ExportProject',
        request,
        metadata || {},
        this.methodDescriptorExportProject,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/ExportProject',
    request,
    metadata || {},
    this.methodDescriptorExportProject);
  }

  methodDescriptorListInstructionBackgrounds = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/ListInstructionBackgrounds',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.ListInstructionBackgroundsRequest,
    minibook_v1_minibook_pb.ListInstructionBackgroundsResponse,
    (request: minibook_v1_minibook_pb.ListInstructionBackgroundsRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.ListInstructionBackgroundsResponse.deserializeBinary
  );

  listInstructionBackgrounds(
    request: minibook_v1_minibook_pb.ListInstructionBackgroundsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.ListInstructionBackgroundsResponse>;

  listInstructionBackgrounds(
    request: minibook_v1_minibook_pb.ListInstructionBackgroundsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.ListInstructionBackgroundsResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.ListInstructionBackgroundsResponse>;

  listInstructionBackgrounds(
    request: minibook_v1_minibook_pb.ListInstructionBackgroundsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.ListInstructionBackgroundsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/ListInstructionBackgrounds',
        request,
        metadata || {},
        this.methodDescriptorListInstructionBackgrounds,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/ListInstructionBackgrounds',
    request,
    metadata || {},
    this.methodDescriptorListInstructionBackgrounds);
  }

  methodDescriptorCreateInstructionBackground = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/CreateInstructionBackground',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.CreateInstructionBackgroundRequest,
    minibook_v1_minibook_pb.CreateInstructionBackgroundResponse,
    (request: minibook_v1_minibook_pb.CreateInstructionBackgroundRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.CreateInstructionBackgroundResponse.deserializeBinary
  );

  createInstructionBackground(
    request: minibook_v1_minibook_pb.CreateInstructionBackgroundRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.CreateInstructionBackgroundResponse>;

  createInstructionBackground(
    request: minibook_v1_minibook_pb.CreateInstructionBackgroundRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.CreateInstructionBackgroundResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.CreateInstructionBackgroundResponse>;

  createInstructionBackground(
    request: minibook_v1_minibook_pb.CreateInstructionBackgroundRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.CreateInstructionBackgroundResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/CreateInstructionBackground',
        request,
        metadata || {},
        this.methodDescriptorCreateInstructionBackground,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/CreateInstructionBackground',
    request,
    metadata || {},
    this.methodDescriptorCreateInstructionBackground);
  }

  methodDescriptorUpdateInstructionBackground = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/UpdateInstructionBackground',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.UpdateInstructionBackgroundRequest,
    minibook_v1_minibook_pb.UpdateInstructionBackgroundResponse,
    (request: minibook_v1_minibook_pb.UpdateInstructionBackgroundRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.UpdateInstructionBackgroundResponse.deserializeBinary
  );

  updateInstructionBackground(
    request: minibook_v1_minibook_pb.UpdateInstructionBackgroundRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.UpdateInstructionBackgroundResponse>;

  updateInstructionBackground(
    request: minibook_v1_minibook_pb.UpdateInstructionBackgroundRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.UpdateInstructionBackgroundResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.UpdateInstructionBackgroundResponse>;

  updateInstructionBackground(
    request: minibook_v1_minibook_pb.UpdateInstructionBackgroundRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.UpdateInstructionBackgroundResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/UpdateInstructionBackground',
        request,
        metadata || {},
        this.methodDescriptorUpdateInstructionBackground,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/UpdateInstructionBackground',
    request,
    metadata || {},
    this.methodDescriptorUpdateInstructionBackground);
  }

  methodDescriptorDeleteInstructionBackground = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/DeleteInstructionBackground',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.DeleteInstructionBackgroundRequest,
    minibook_v1_minibook_pb.DeleteInstructionBackgroundResponse,
    (request: minibook_v1_minibook_pb.DeleteInstructionBackgroundRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.DeleteInstructionBackgroundResponse.deserializeBinary
  );

  deleteInstructionBackground(
    request: minibook_v1_minibook_pb.DeleteInstructionBackgroundRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.DeleteInstructionBackgroundResponse>;

  deleteInstructionBackground(
    request: minibook_v1_minibook_pb.DeleteInstructionBackgroundRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.DeleteInstructionBackgroundResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.DeleteInstructionBackgroundResponse>;

  deleteInstructionBackground(
    request: minibook_v1_minibook_pb.DeleteInstructionBackgroundRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.DeleteInstructionBackgroundResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/DeleteInstructionBackground',
        request,
        metadata || {},
        this.methodDescriptorDeleteInstructionBackground,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/DeleteInstructionBackground',
    request,
    metadata || {},
    this.methodDescriptorDeleteInstructionBackground);
  }

  methodDescriptorGetActiveInstructionBackground = new grpcWeb.MethodDescriptor(
    '/minibook.v1.MiniBookService/GetActiveInstructionBackground',
    grpcWeb.MethodType.UNARY,
    minibook_v1_minibook_pb.GetActiveInstructionBackgroundRequest,
    minibook_v1_minibook_pb.GetActiveInstructionBackgroundResponse,
    (request: minibook_v1_minibook_pb.GetActiveInstructionBackgroundRequest) => {
      return request.serializeBinary();
    },
    minibook_v1_minibook_pb.GetActiveInstructionBackgroundResponse.deserializeBinary
  );

  getActiveInstructionBackground(
    request: minibook_v1_minibook_pb.GetActiveInstructionBackgroundRequest,
    metadata?: grpcWeb.Metadata | null): Promise<minibook_v1_minibook_pb.GetActiveInstructionBackgroundResponse>;

  getActiveInstructionBackground(
    request: minibook_v1_minibook_pb.GetActiveInstructionBackgroundRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.GetActiveInstructionBackgroundResponse) => void): grpcWeb.ClientReadableStream<minibook_v1_minibook_pb.GetActiveInstructionBackgroundResponse>;

  getActiveInstructionBackground(
    request: minibook_v1_minibook_pb.GetActiveInstructionBackgroundRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: minibook_v1_minibook_pb.GetActiveInstructionBackgroundResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/minibook.v1.MiniBookService/GetActiveInstructionBackground',
        request,
        metadata || {},
        this.methodDescriptorGetActiveInstructionBackground,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/minibook.v1.MiniBookService/GetActiveInstructionBackground',
    request,
    metadata || {},
    this.methodDescriptorGetActiveInstructionBackground);
  }

}

